import { ISelectOption } from './selectOption.interface';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ResourceCategory } from '../api/inventoryResource.model';
import { getResourceCategoryIconPath, getResourceCategoryDisplayName } from 'src/app/common/categoryUtils';
import { BeautifyDisplayStringPipe } from 'src/app/pipes/beautify-display-string/beautify-display-string.pipe';
import { FeatureFlagsService } from 'src/app/services/infra/featureFlags/feature-flags.service';
import { FeatureFlagTypes } from '../featureFlag/featureFlagsTypes.enum';

const resourceCategoryDisplayName = 'Category';

export function getResourceCategorySelectOptions(
  beautifyDisplayStringPipe: BeautifyDisplayStringPipe
): ISelectOption[] {
  return [
    {
      id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.generic}`,
      value: ResourceCategory.generic,
      displayName: getResourceCategoryDisplayName(ResourceCategory.generic, beautifyDisplayStringPipe),
      categoryName: resourceCategoryDisplayName,
      filterType: FilterTypesEnum.ResourceCategory,
      iconPath: getResourceCategoryIconPath(ResourceCategory.generic),
    },
    {
      id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.environment}`,
      value: ResourceCategory.environment,
      displayName: getResourceCategoryDisplayName(ResourceCategory.environment, beautifyDisplayStringPipe),
      categoryName: resourceCategoryDisplayName,
      filterType: FilterTypesEnum.ResourceCategory,
      iconPath: getResourceCategoryIconPath(ResourceCategory.environment),
    },
    {
      id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.identity}`,
      value: ResourceCategory.identity,
      displayName: getResourceCategoryDisplayName(ResourceCategory.identity, beautifyDisplayStringPipe),
      categoryName: resourceCategoryDisplayName,
      filterType: FilterTypesEnum.ResourceCategory,
      iconPath: getResourceCategoryIconPath(ResourceCategory.identity),
    },
    {
      id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.automation}`,
      value: ResourceCategory.automation,
      displayName: getResourceCategoryDisplayName(ResourceCategory.automation, beautifyDisplayStringPipe),
      categoryName: resourceCategoryDisplayName,
      filterType: FilterTypesEnum.ResourceCategory,
      iconPath: getResourceCategoryIconPath(ResourceCategory.automation),
    },
    {
      id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.application}`,
      value: ResourceCategory.application,
      displayName: getResourceCategoryDisplayName(ResourceCategory.application, beautifyDisplayStringPipe),
      categoryName: resourceCategoryDisplayName,
      filterType: FilterTypesEnum.ResourceCategory,
      iconPath: getResourceCategoryIconPath(ResourceCategory.application),
    },
    {
      id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.connection}`,
      value: ResourceCategory.connection,
      displayName: getResourceCategoryDisplayName(ResourceCategory.connection, beautifyDisplayStringPipe),
      categoryName: resourceCategoryDisplayName,
      filterType: FilterTypesEnum.ResourceCategory,
      iconPath: getResourceCategoryIconPath(ResourceCategory.connection),
    },
    {
      id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.connector}`,
      value: ResourceCategory.connector,
      displayName: getResourceCategoryDisplayName(ResourceCategory.connector, beautifyDisplayStringPipe),
      categoryName: resourceCategoryDisplayName,
      filterType: FilterTypesEnum.ResourceCategory,
      iconPath: getResourceCategoryIconPath(ResourceCategory.connector),
    },
    {
      id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.dataStorage}`,
      value: ResourceCategory.dataStorage,
      displayName: getResourceCategoryDisplayName(ResourceCategory.dataStorage, beautifyDisplayStringPipe),
      categoryName: resourceCategoryDisplayName,
      filterType: FilterTypesEnum.ResourceCategory,
      iconPath: getResourceCategoryIconPath(ResourceCategory.dataStorage),
    },
    {
      id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.tools}`,
      value: ResourceCategory.tools,
      displayName: getResourceCategoryDisplayName(ResourceCategory.tools, beautifyDisplayStringPipe),
      categoryName: 'Category',
      filterType: FilterTypesEnum.ResourceCategory,
      iconPath: getResourceCategoryIconPath(ResourceCategory.tools),
    },
    {
      id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.device}`,
      value: ResourceCategory.device,
      displayName: getResourceCategoryDisplayName(ResourceCategory.device, beautifyDisplayStringPipe),
      categoryName: resourceCategoryDisplayName,
      filterType: FilterTypesEnum.ResourceCategory,
      iconPath: getResourceCategoryIconPath(ResourceCategory.device),
    },
    {
      id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.bot}`,
      value: ResourceCategory.bot,
      displayName: getResourceCategoryDisplayName(ResourceCategory.bot, beautifyDisplayStringPipe),
      categoryName: resourceCategoryDisplayName,
      filterType: FilterTypesEnum.ResourceCategory,
      iconPath: getResourceCategoryIconPath(ResourceCategory.bot),
    },
    {
      id: `${FilterTypesEnum.ResourceCategory}-${ResourceCategory.aiExtension}`,
      value: ResourceCategory.aiExtension,
      displayName: getResourceCategoryDisplayName(ResourceCategory.aiExtension, beautifyDisplayStringPipe),
      categoryName: resourceCategoryDisplayName,
      filterType: FilterTypesEnum.ResourceCategory,
      iconPath: getResourceCategoryIconPath(ResourceCategory.aiExtension),
    },
  ];
}
// TODO: when devices FF removed delete getFilteredResourceCategorySelectOptions
// #### Devices FF ####
export function getFilteredResourceCategorySelectOptions(
  beautifyDisplayStringPipe: BeautifyDisplayStringPipe,
  featureFlagsService: FeatureFlagsService
): ISelectOption[] {
  let options = getResourceCategorySelectOptions(beautifyDisplayStringPipe);

  if (!featureFlagsService.isFeatureEnabled(FeatureFlagTypes.Devices)) {
    options = options.filter((option) => option.value !== ResourceCategory.device);
  }

  return options;
}
